export const initialLetterName = (value: string | undefined): string => {
  if (value) {
    const names = value.split(" ");
    if (names.length >= 2) {
      const firstNameInitial = names[0].charAt(0);
      const lastNameInitial = names[names.length - 1].charAt(0);
      return `${firstNameInitial}${lastNameInitial}`;
    }
    return value.charAt(0);
  }
  return " ";
};
